module.exports = __webpack_public_path__ + "img/broadcom.ea2dada8.jpg";